import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { ClickEventListener } from '@philips-emr/tws-core/lib/component/types';

export default class HpmsIndiceReajusteApi extends ComponentAPI<never>{

  @AwesomeEvent
  onOpenAttachment = new ClickEventListener();

  @AwesomeEvent
  onOpenModalDocumento = new ClickEventListener();

}
